import initialState from './initialState'

import {
  SET_CURRENT_PRESET,

  SET_MIDI_CHANNEL,
  SET_PRESSURE_CC,
  SET_TILT_CC,
  SET_BEND_RANGE_PAD,
  SET_BEND_RANGE_TILT,
  SET_VELOCITY_SENSITIVITY,
  SET_PRESSURE_SENSITIVITY,
  SET_TILT_SENSITIVITY,

  TOGGLE_MPE,
  SET_MPE_MEMBER_CHANNELS,

  SET_VELOCITY_CURVE,
  SET_PRESSURE_DISABLED_RETURN,
  SET_TILT_DISABLED_RETURN,
  SET_ON_THRESHOLD,

  REVERT_PRESET,
  REVERT_PREFERENCES,
  REVERT_SENSITIVITIES
} from '../actions/actionTypes'

export default function currentPresetReducer(state = initialState.currentPreset, action) {
  switch (action.type) {
    case SET_CURRENT_PRESET:
      return {
        ...action.preset
      }
    case SET_MIDI_CHANNEL:
      return {
        ...state,
        midi_channel: action.channel
      }
    case TOGGLE_MPE:
      return {
        ...state,
        mpe_active: !state.mpe_active
      }
    case SET_MPE_MEMBER_CHANNELS:
      return {
        ...state,
        mpe_member_channels: action.channels
      }
    case SET_PRESSURE_CC:
      return {
        ...state,
        pressure_cc: action.cc
      }
    case SET_TILT_CC:
      return {
        ...state,
        tilt_cc: action.cc
      }
    case SET_BEND_RANGE_PAD:
      return {
        ...state,
        bend_range_pad: action.range
      }
    case SET_BEND_RANGE_TILT:
      return {
        ...state,
        bend_range_tilt: action.range
      }
    case SET_VELOCITY_SENSITIVITY:
      return {
        ...state,
        velocity_sensitivity: action.sensitivity

      }
    case SET_PRESSURE_SENSITIVITY:
      return {
        ...state,
        pressure_sensitivity: action.sensitivity
      }
    case SET_TILT_SENSITIVITY:
      return {
        ...state,
        tilt_sensitivity: action.sensitivity
      }
    // in preferences
    case SET_VELOCITY_CURVE:
      return {
        ...state,
        velocity_curve: action.curve
      }
    case SET_PRESSURE_DISABLED_RETURN:
      return {
        ...state,
        pressure_disabled_return: action.value
      }
    case SET_TILT_DISABLED_RETURN:
      return {
        ...state,
        tilt_disabled_return: action.value
      }
    case SET_ON_THRESHOLD:
      return {
        ...state,
        on_thresh: action.threshold
      }
    case REVERT_PRESET:
      return {
        ...state,
        midi_channel: 0,
        pressure_cc: 1,
        tilt_cc: -1,
        bend_range_tilt: 1,
        bend_range_pad: 12,
        pressure_sensitivity: 100,
        tilt_sensitivity: 50,
        velocity_sensitivity: 100
      }
    case REVERT_PREFERENCES:
      return {
        ...state,
        velocity_curve: "Linear",
        pressure_disabled_return: -1,
        tilt_disabled_return: -1,
        on_thresh: 30
      }
    case REVERT_SENSITIVITIES:
      return {
        ...state,
        pressure_sensitivity: 100,
        tilt_sensitivity: 50,
        velocity_sensitivity: 100
      }
    default:
      return state
  }
}
